<template>
  <div ref="Drawer">
    <a-drawer v-model:open="open" class="custom-class" root-class-name="root-class-name" :closable="false"
      placement="right" :width="'808px'" @after-open-change="afterOpenChange" @close="cancel"
      wrapClassName="drawer-style" :getContainer="() => Drawer">
      <template v-slot:title>
        <div>
          <img :src="require('@/assets/icons/bg_icon.png')" style="width: 25px; vertical-align: bottom" alt="" />

          <span class="ml10 first_title">报告详情</span>
        </div>
      </template>
      <template #extra>
        <div class="back" @click="closeOpen">
          <a-button type="primary">
            <i class="iconfont icon-fanhuiicon mr5"></i>返回
          </a-button>
        </div>
      </template>
      <template v-if="drawerTitle != '报告详情'" #footer>
        <div class="botm">
          <a-button type="primary" ghost @click="cancelDrawer">取消</a-button>
          <a-button type="primary" style="margin-left: 61px" @click="confirm">确定</a-button>
        </div>
      </template>

      <div class="drawer_content">
        <div class="left_ant_right">
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '上传脱离报告'" class="left">
            测试牌照
          </div>
          <div v-if="drawerTitle === '报告详情'" class="right">
            {{ form.testCarNum }}
          </div>
          <div v-if="drawerTitle === '上传脱离报告'" class="right">
            <a-select v-model:value="form.carId" style="width: 380px" placeholder="请选择" @change="testCarNumChange">
              <a-select-option v-for="item in testCarNumList" :key="item.id" :value="item.id">{{ item.testCarNum
                }}</a-select-option>
            </a-select>
          </div>
        </div>

        <div class="left_ant_right">
          <div class="left">急刹开始时间</div>
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '完善报告'" class="right">
            {{ form.emergencyBrakeStartTimeStr }}
          </div>
          <div v-else class="right">
            <a-date-picker show-time placeholder="选择时间" style="width: 380px" format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.emergencyBrakeStartTimeStr" />
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">急刹结束时间</div>
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '完善报告'" class="right">
            {{ form.emergencyBrakeEndTimeStr }}
          </div>
          <div v-else class="right">
            <a-date-picker show-time placeholder="选择时间" style="width: 380px" format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.emergencyBrakeEndTimeStr" />
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">急刹地点[经纬度]</div>
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '完善报告'" class="right">
            {{ form.emergencyBrakePoint }}
          </div>
          <div v-else class="right">
            <a-input style="width: 380px" v-model:value="form.emergencyBrakePoint" placeholder="请输入" />
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">急刹时平均减速度[m/s²]</div>
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '完善报告'" class="right">
            {{ form.emergencyAvgDeceleration }}
          </div>
          <div v-else class="right">
            <a-input style="width: 380px" v-model:value="form.emergencyAvgDeceleration" placeholder="请输入" />
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">急刹时最大减速度[m/s²]</div>
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '完善报告'" class="right">
            {{ form.emergencyMaxDeceleration }}
          </div>
          <div v-else class="right">
            <a-input style="width: 380px" v-model:value="form.emergencyMaxDeceleration" placeholder="请输入" />
          </div>
        </div>
        <div class="left_ant_right" style="align-items: start; margin-bottom: 0">
          <div class="left">急刹时场景分类</div>
          <div class="right" style="width: 507px">
            <a-radio-group v-model:value="form.emergencyBrakeScene" :disabled="drawerTitle === '报告详情' ? true : false"
              @change="radioChange">
              <a-radio v-for="(item, index) in emergencyBrakeScene" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue }}
                <div v-if="item.dataValue === '其他' && flag">
                  <input :disabled="drawerTitle === '报告详情' ? true : false" class="old_inp" type="text"
                    v-model="userInput" />
                </div>
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right" style="align-items: start; margin-bottom: 0">
          <div class="left">急刹时主要交通参与者类型</div>
          <div class="right" style="width: 495px">
            <a-radio-group v-model:value="form.emergencyBrakeMajorParticipant"
              :disabled="drawerTitle === '报告详情' ? true : false" @change="radioChange2">
              <a-radio v-for="(item, index) in emergencyBrakeMajorParticipant" :key="item.id"
                :value="item.dataCode + ''">{{
                  item.dataValue }}
                <div v-if="item.dataValue === '其他' && flag2">
                  <input :disabled="drawerTitle === '报告详情' ? true : false" class="old_inp" type="text"
                    v-model="userInput2" />
                </div>
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right" style="align-items: start; margin-bottom: 0">
          <div class="left">急刹时主要交通设施</div>
          <div class="right" style="width: 495px">
            <a-radio-group v-model:value="form.emergencyBrakeMajorFacility"
              :disabled="drawerTitle === '报告详情' ? true : false" @change="radioChange3">
              <a-radio v-for="(item, index) in emergencyBrakeMajorFacility" :key="item.id"
                :value="item.dataCode + ''">{{
                  item.dataValue }}
                <div v-if="item.dataValue === '其他' && flag3">
                  <input :disabled="drawerTitle === '报告详情' ? true : false" class="old_inp" type="text"
                    v-model="userInput3" />
                </div>
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right" style="margin-bottom: 0">
          <div class="left" style="margin-bottom: 24px">急刹类别</div>
          <div class="right">
            <a-radio-group :disabled="drawerTitle === '报告详情' ? true : false"
              v-model:value="form.emergencyBrakeCategory">
              <a-radio v-for="(item, index) in emergencyBrakeCategory" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>

        <div class="left_ant_right">
          <div class="left">急刹原因及情况详细说明</div>
          <div v-if="drawerTitle === '报告详情'" class="right">
            {{ form.emergencyBrakeDetailedDescription }}
          </div>
          <div v-else class="right">
            <a-input style="width: 380px" v-model:value="form.emergencyBrakeDetailedDescription" placeholder="请输入" />
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">急刹报告提交日期</div>
          <div v-if="drawerTitle === '报告详情'" class="right">
            {{ form.submitDateStr }}
          </div>
          <div v-else class="right">
            <a-date-picker show-time placeholder="选择时间" style="width: 380px" format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD" v-model:value="form.submitDateStr" />
          </div>
        </div>
        <!-- <div class="left_ant_right" style="margin-bottom: 26px;margin-left: 90px;">
          <div class="left" style="width: 100px;">急刹视频</div>

          <div class="right">
            <video class="video-area-main-body" autoplay muted loop :src="form.videoUrls">
            </video>
          </div>

        </div> -->
      </div>
<!--      <a-tabs style="margin-left: 60px;width:590px" v-model:activeKey="activeKey">-->
<!--        <a-tab-pane :key="0" tab="车外">-->
<!--          &lt;!&ndash; <img src="@/assets/images/car1.png" alt=""> &ndash;&gt;-->
<!--&lt;!&ndash;          <video class="video-area-main-body" autoplay muted loop :src="form.videoUrls ? form.videoUrls[0] : ''">&ndash;&gt;-->
<!--&lt;!&ndash;          </video>&ndash;&gt;-->
<!--          <div v-if="historyVideos && historyVideos.length > 0">-->
<!--            <video-->
<!--                v-for="(item, index) in historyVideos"-->
<!--                :key="index"-->
<!--                class="video-area-main-body"-->
<!--                controls-->
<!--                muted-->
<!--                loop-->
<!--                :src="item.outVideo ? item.outVideo : ''"-->
<!--                style="margin-bottom: 10px;"-->
<!--            />-->
<!--          </div>-->
<!--        </a-tab-pane>-->
<!--        <a-tab-pane :key="1" tab="车内">-->
<!--          &lt;!&ndash; <img src="@/assets/images/car1.png" alt=""> &ndash;&gt;-->
<!--&lt;!&ndash;          <video class="video-area-main-body" autoplay muted loop :src="form.videoUrls ? form.videoUrls[1] : ''">&ndash;&gt;-->
<!--&lt;!&ndash;          </video>&ndash;&gt;-->
<!--          <div v-if="historyVideos && historyVideos.length > 0">-->
<!--            <video-->
<!--                v-for="(item, index) in historyVideos"-->
<!--                :key="index"-->
<!--                class="video-area-main-body"-->
<!--                controls-->
<!--                muted-->
<!--                loop-->
<!--                :src="item.inVideo ? item.inVideo : ''"-->
<!--                style="margin-bottom: 10px;"-->
<!--            />-->
<!--          </div>-->
<!--        </a-tab-pane>-->
<!--        <a-tab-pane :key="2" tab="刹车踏板">-->
<!--          &lt;!&ndash; <img src="@/assets/images/car1.png" alt=""> &ndash;&gt;-->
<!--&lt;!&ndash;          <video class="video-area-main-body" autoplay muted loop :src="form.videoUrls ? form.videoUrls[2] : ''">&ndash;&gt;-->
<!--&lt;!&ndash;          </video>&ndash;&gt;-->
<!--          <div v-if="historyVideos && historyVideos.length > 0">-->
<!--            <video-->
<!--                v-for="(item, index) in historyVideos"-->
<!--                :key="index"-->
<!--                class="video-area-main-body"-->
<!--                controls-->
<!--                muted-->
<!--                loop-->
<!--                :src="item.breakVideo ? item.breakVideo : ''"-->
<!--                style="margin-bottom: 10px;"-->
<!--            />-->
<!--          </div>-->
<!--        </a-tab-pane>-->
<!--      </a-tabs>-->
      <a-tabs style="margin-left: 60px;width:590px" v-model:activeKey="activeKey" class="tab-content-container" forceRender>
        <a-tab-pane :key="0" tab="车外">
          <div v-if="historyVideos && historyVideos.length > 0">
            <VideoPlayer
                v-for="(item, index) in historyVideos"
                :key="index"
                :src="item.outVideo || ''"
                :videoId="`dynamic-video-out-${index}`"
                className="video-area-main-body"
                :muted="true"
                :loop="true"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane :key="1" tab="车内">
          <div v-if="historyVideos && historyVideos.length > 0">
            <VideoPlayer
                v-for="(item, index) in historyVideos"
                :key="index"
                :src="item.inVideo || ''"
                :videoId="`dynamic-video-in-${index}`"
                className="video-area-main-body"
                :muted="true"
                :loop="true"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="刹车踏板">
          <div v-if="historyVideos && historyVideos.length > 0">
            <VideoPlayer
                v-for="(item, index) in historyVideos"
                :key="index"
                :src="item.breakVideo || ''"
                :videoId="`dynamic-video-break-${index}`"
                className="video-area-main-body"
                :muted="true"
                :loop="true"
            />
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  defineExpose,
  toRaw,
  defineProps,
  defineEmits,
  watch,
} from "vue";
import { cloneDeep } from "lodash-es";
import { message } from "ant-design-vue";
import { detailById, checkIdCardNumRepeat } from "@/api/securityUser/index.js";
import moment from "moment";
import { detail, getHistoryVideos } from "@/api/report/emergency.js";
import { getCars } from "@/api/car/car.js";
import VideoPlayer from '@/components/videoPlayer/index.vue';

import useUserStore from "@/store/modules/user";
const store = useUserStore();

import useAppStore from "@/store/modules/app";
const appStore = useAppStore();

const dataType = "emergencyBrakeScene";
const dataType2 = "emergencyBrakeParticipant";
const dataType3 = "emergencyBrakeFacility";
const dataType4 = "emergencyBrakeCategory";

const Drawer = ref();
const props = defineProps({
  drawerTitle: {
    type: String,
    default: "",
  },
});

const open = ref(false);
const formRef = ref();

const form = ref({
  carId: undefined,
  emergencyBrakeStartTimeStr: "",
  emergencyBrakeEndTimeStr: "",
  emergencyBrakePoint: "",
  emergencyAvgDeceleration: "",
  emergencyMaxDeceleration: "",
  emergencyBrakeScene: "1",
  emergencyBrakeMajorParticipant: "1",
  emergencyBrakeMajorFacility: "1",
  emergencyBrakeCategory: "1",
  emergencyBrakeDetailedDescription: "",
  submitDateStr: "",
  testCarNum: "",
  videoUrls: "",
});

const historyVideos = ref([]);

const userInput = ref("");
const emergencyBrakeScene = ref([]);
const activeKey = ref(0);

watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType);
      emergencyBrakeScene.value = val[index].children;
      console.log(emergencyBrakeScene.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const userInput2 = ref("");
const emergencyBrakeMajorParticipant = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType2);
      emergencyBrakeMajorParticipant.value = val[index].children;
      console.log(emergencyBrakeMajorParticipant.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const userInput3 = ref("");
const emergencyBrakeMajorFacility = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType3);
      emergencyBrakeMajorFacility.value = val[index].children;
      console.log(emergencyBrakeMajorFacility.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const emergencyBrakeCategory = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType4);
      emergencyBrakeCategory.value = val[index].children;
      console.log(emergencyBrakeCategory.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

watch(
    () => historyVideos.value,
    (newVal) => {
      if (newVal && newVal.length > 0) {
        console.log('historyVideos数据已更新，数量:', newVal.length);
      }
    },
    { deep: true }
);
const reset = () => {
  form.value = {
    carId: undefined,
    emergencyBrakeStartTimeStr: "",
    emergencyBrakeEndTimeStr: "",
    emergencyBrakePoint: "",
    emergencyAvgDeceleration: "",
    emergencyMaxDeceleration: "",
    emergencyBrakeScene: "1",
    emergencyBrakeMajorParticipant: "1",
    emergencyBrakeMajorFacility: "1",
    emergencyBrakeCategory: "1",
    emergencyBrakeDetailedDescription: "",
    submitDateStr: "",
    testCarNum: "",
    videoUrls: "",
  };
  flag.value = false;
  flag2.value = false;
  flag3.value = false;
  userInput.value = "";
  userInput2.value = "";
  userInput3.value = "";
};

const afterOpenChange = (bool) => {
  console.log("open", bool);
};

const testCarNumList = ref([]);
const getCarsData = () => {
  getCars({
    pageIndex: null,
    pageSize: null,
    conditionMap: {
      deptName: "",
      frameNum: "",
      testCarNum: "",
      deptIdStr: store.deptId,
    },
  }).then((res) => {
    console.log(res);
    if (res.code === 200) {
      testCarNumList.value = res.data.total;
    }
  });
};

const testCarNumChange = (value) => {
  console.log(value);
  let res = testCarNumList.value.find((item) => item.id === value);
  console.log(res);
  form.value.testCarNum = res.testCarNum;
};

const showDrawer = (data) => {
  open.value = true;
  reset();
  if (data) {
    console.log(data);
    detail({ id: data.id }).then((res) => {
      console.log(res);
      if (res.code === 200) {
        form.value = res.data;
        if (
          res.data.emergencyBrakeScene.indexOf("0_") != -1 ||
          res.data.emergencyBrakeScene.indexOf("0") != -1
        ) {
          flag.value = true;
          let arr = res.data.emergencyBrakeScene.split("_");
          console.log(arr);
          form.value.emergencyBrakeScene = arr[0];
          userInput.value = arr[1];
        }

        if (
          res.data.emergencyBrakeMajorParticipant.indexOf("0_") != -1 ||
          res.data.emergencyBrakeMajorParticipant.indexOf("0") != -1
        ) {
          flag2.value = true;
          let arr = res.data.emergencyBrakeMajorParticipant.split("_");
          console.log(arr);
          form.value.emergencyBrakeMajorParticipant = arr[0];
          userInput2.value = arr[1];
        }

        if (
          res.data.emergencyBrakeMajorFacility.indexOf("0_") != -1 ||
          res.data.emergencyBrakeMajorFacility.indexOf("0") != -1
        ) {
          flag3.value = true;
          let arr = res.data.emergencyBrakeMajorFacility.split("_");
          console.log(arr);
          form.value.emergencyBrakeMajorFacility = arr[0];
          userInput3.value = arr[1];
        }
        form.value.id = data.id;
      }
    });
    getHistoryVideos( {id: data.id} ).then((res) => {
      historyVideos.value = res.data
    })
  }
  getCarsData();
};
const closeOpen = () => {
  open.value = false;
};
const cancel = () => {
  console.log("取消");
  open.value = false;
};

const flag = ref(false);
const flag2 = ref(false);
const flag3 = ref(false);
const radioChange = (e) => {
  console.log(e.target.value);
  if (e.target.value === "0") {
    flag.value = true;
  } else {
    flag.value = false;
  }
};
const radioChange2 = (e) => {
  console.log(e.target.value);
  if (e.target.value === "0") {
    flag2.value = true;
  } else {
    flag2.value = false;
  }
};
const radioChange3 = (e) => {
  console.log(e.target.value);
  if (e.target.value === "0") {
    flag3.value = true;
  } else {
    flag3.value = false;
  }
};

const emit = defineEmits(["drawerEvent"]);
// 保存
const confirm = () => {
  console.log("保存");
  console.log("values", form.value);
  const drawerValue = JSON.parse(JSON.stringify(form.value));
  if (drawerValue.emergencyBrakeScene === "0" && userInput.value !== "") {
    drawerValue.emergencyBrakeScene =
      drawerValue.emergencyBrakeScene + "_" + userInput.value;
  }

  if (
    drawerValue.emergencyBrakeMajorParticipant === "0" &&
    userInput2.value !== ""
  ) {
    drawerValue.emergencyBrakeMajorParticipant =
      drawerValue.emergencyBrakeMajorParticipant + "_" + userInput2.value;
  }

  if (
    drawerValue.emergencyBrakeMajorFacility === "0" &&
    userInput3.value !== ""
  ) {
    drawerValue.emergencyBrakeMajorFacility =
      drawerValue.emergencyBrakeMajorFacility + "_" + userInput3.value;
  }

  emit("drawerEvent", drawerValue);
  open.value = false;
};
// 取消
const cancelDrawer = () => {
  console.log("取消");
  open.value = false;
};
// 使用 defineExpose 向外暴露指定的数据和方法
defineExpose({
  showDrawer,
});
</script>
<style lang="less" scoped>
.first_title {
  color: rgba(29, 33, 41, 0.7);
  font-weight: 600;
  font-size: 18px;
}

.drawer_content {
  padding-left: 36px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}

.left_ant_right {
  display: flex;
  align-items: center;
  margin-bottom: 23px;

  .left {
    width: 190px;
    text-align: right;
  }

  .right {
    margin-left: 32px;
  }
}

.video-area-main-body {
  width: 76%;
  // height: 300px;
  // background: skyblue
}

/deep/.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f2f4f7;
}

/deep/ .ant-drawer .ant-drawer-footer {
  display: flex;
  justify-content: center;
  border-top: 0px;
  margin-bottom: 40px;
}

/deep/ .ant-drawer .ant-drawer-header {
  border-bottom: 0px;
}

/deep/.ant-drawer-title {
  color: rgba(29, 33, 41, 1);
  font-weight: 600;
  font-size: 18px;
}

/deep/.ant-radio-wrapper span.ant-radio+* {
  width: 100px;
}

/deep/.ant-radio-wrapper {
  margin-bottom: 24px;
}

.old_inp {
  /* 移除原生边框 */
  border: none;
  /* 添加新边框*/
  border-bottom: 1px solid #000;
  /* 左侧内边距 */
  // padding-left: 10px;
  /* 输入框宽度 */
  width: 80px;
  /* 移除点击输入框时浏览器提供的默认轮廓 */
  outline: none;
  position: absolute;
  bottom: 3px;
  left: 70px;
}

/deep/ .ant-tabs-tabpane {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: 1;
  transform: translateX(0);
  position: absolute;
  width: 100%;
}

/deep/ .ant-tabs-tabpane-inactive {
  opacity: 1;
  transform: translateX(0);
  position: absolute;
  width: 100%;
  pointer-events: none;
}

/* 确保标签内容容器有固定高度，防止重绘时布局跳动 */
.tab-content-container {
  min-height: 350px;
  position: relative;
}
</style>
